import { SingleNews } from '@api';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';

export const useArticleDrawer = (source: PosthogTrackingSource) => {
  const { params, deleteQueryParam, setQueryParams } = useQueryParams();
  const { trackNewsDrawerOpen } = usePosthogEvents();

  const handleSelectSingleNews = (article: SingleNews) => {
    trackNewsDrawerOpen(source);
    setQueryParams({
      [queryKeys.activeArticleId]: article?.id,
      [queryKeys.activeDrawer]: 'article',
    });
  };

  const closeDrawer = () => {
    deleteQueryParam([queryKeys.activeArticleId, queryKeys.activeDrawer]);
  };

  return {
    handleSelectSingleNews,
    closeDrawer,
    singleNewsId: params.activeArticleId,
  };
};
